import { CALL_API } from 'middleware/api';
import { ACTIVATE_VPN_FAILURE, ACTIVATE_VPN_REQUEST, ACTIVATE_VPN_SUCCESS, GET_VPN_STATUS_FAILURE, GET_VPN_STATUS_REQUEST, GET_VPN_STATUS_SUCCESS, SET_VPN_STATUS, } from './types';
export const getVPNStatus = () => ({
    [CALL_API]: {
        endpoint: '/nordvpn/status',
        method: 'GET',
        types: [
            GET_VPN_STATUS_REQUEST,
            GET_VPN_STATUS_SUCCESS,
            GET_VPN_STATUS_FAILURE,
        ],
    },
});
export const activateVPN = () => ({
    [CALL_API]: {
        endpoint: '/nordvpn/activate',
        method: 'POST',
        types: [ACTIVATE_VPN_REQUEST, ACTIVATE_VPN_SUCCESS, ACTIVATE_VPN_FAILURE],
    },
});
export const setVpnStatus = (status) => ({ type: SET_VPN_STATUS, payload: { status } });
